"use strict";
/*
 * Created on 14. 12. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var moment = require("moment");

var Parser_1 = require("../model/data-dictionary/Parser");

var DateParser_1 = require("../model/data-dictionary/parsers/DateParser");

var ValidationLevel_1 = require("../model/data-dictionary/ValidationLevel");

var index_1 = require("./index");
/**
 * @author Radek Beran
 */


var ParamParsers =
/*#__PURE__*/
function () {
  function ParamParsers() {
    _classCallCheck(this, ParamParsers);
  }

  _createClass(ParamParsers, null, [{
    key: "parseBoolean",
    // TODO RBe: Implement these methods in terms of BooleanParser and other possible parsers in data-dictionary
    value: function parseBoolean(params, paramName, defaultValue) {
      var paramValue = params[paramName];

      if (!index_1.Utils.isValueMissing(paramValue)) {
        return paramValue === 'true' || paramValue === true || paramValue === '1' || paramValue === 1;
      }

      if (index_1.Utils.isBool(defaultValue)) {
        return defaultValue;
      }

      return null;
    }
  }, {
    key: "parseDate",
    value: function parseDate(params, paramName, defaultValue) {
      return ParamParsers.parseDateWithFormat(params, paramName, DateParser_1.DateParser.ISO_PATTERN, defaultValue);
    }
  }, {
    key: "parseDateWithFormat",
    value: function parseDateWithFormat(params, paramName, format, defaultValue) {
      var paramValue = params[paramName];

      if (!index_1.Utils.isValueMissing(paramValue)) {
        if (moment.isMoment(paramValue)) {
          return paramValue;
        }

        var mom = moment(paramValue, format, true);

        if (mom.isValid()) {
          return mom;
        }

        throw new Error('Invalid date: ' + paramValue);
      }

      if (moment.isMoment(defaultValue)) {
        return defaultValue;
      }

      return null;
    }
  }, {
    key: "parseString",
    value: function parseString(params, paramName) {
      var paramValue = params[paramName];

      if (index_1.Utils.isString(paramValue)) {
        return paramValue;
      }

      return null;
    }
  }, {
    key: "parseNumber",
    value: function parseNumber(params, paramName, defaultValue) {
      var paramValue = params[paramName];

      if (!isNaN(paramValue)) {
        return Number(paramValue);
      }

      if (index_1.Utils.isNumber(defaultValue)) {
        return defaultValue;
      }

      return null;
    }
  }, {
    key: "parseEnumValue",
    value: function parseEnumValue(params, paramName, enumClass) {
      var paramValue = params[paramName];

      if (index_1.Utils.isString(paramValue)) {
        var parser = new Parser_1.EnumParser(enumClass);
        return parser.parse(paramValue, ValidationLevel_1.ValidationLevel.Basic).get();
      }

      return null;
    }
  }, {
    key: "parseList",
    value: function parseList(params, paramName) {
      var values = params[paramName];

      if (index_1.Utils.isArray(values)) {
        return immutable_1.List(values);
      }

      return null;
    }
  }, {
    key: "parseSet",
    value: function parseSet(params, paramName) {
      var values = params[paramName];

      if (index_1.Utils.isArray(values)) {
        return immutable_1.Set(values);
      }

      return null;
    }
  }, {
    key: "parseMap",
    value: function parseMap(params, paramName) {
      var values = params[paramName];

      if (index_1.Utils.isArray(values)) {
        return immutable_1.Map(values);
      }

      return null;
    }
  }, {
    key: "parseArrayOfNumbers",
    value: function parseArrayOfNumbers(params, paramName) {
      var values = params[paramName];

      if (index_1.Utils.isArray(values)) {
        var parser = new Parser_1.NumberParser();
        return values.map(function (v) {
          return parser.parse(v, ValidationLevel_1.ValidationLevel.Basic).get();
        });
      }

      return null;
    }
  }, {
    key: "parseListOfNumbers",
    value: function parseListOfNumbers(params, paramName) {
      var array = this.parseArrayOfNumbers(params, paramName);
      return array ? immutable_1.List(array) : null;
    }
  }, {
    key: "parseListOfEnumValues",
    value: function parseListOfEnumValues(params, paramName, enumClass) {
      var values = params[paramName];

      if (index_1.Utils.isArray(values)) {
        var parser = new Parser_1.EnumParser(enumClass);
        return immutable_1.List(values.map(function (v) {
          return parser.parse(v, ValidationLevel_1.ValidationLevel.Basic).get();
        }));
      }

      return null;
    }
  }, {
    key: "parseStringOrList",
    value: function parseStringOrList(params, singleParamName, listParamName) {
      var singleValue = params[singleParamName];

      if (index_1.Utils.isString(singleValue)) {
        return immutable_1.List.of(singleValue);
      } else {
        var values = params[listParamName];

        if (index_1.Utils.isArray(values)) {
          return immutable_1.List(values);
        } else if (index_1.Utils.isString(values)) {
          return immutable_1.List.of(values);
        }

        return null;
      }
    }
  }]);

  return ParamParsers;
}();

exports.ParamParsers = ParamParsers;